goog.provide('yext.location.IntegerRangeSelect');
goog.provide('yext.location.IntegerRangeModel');

goog.require('yext');
goog.require('yext.location.helpers');
/** @suppress {extraRequire} */
goog.require('yext.plugins.selectbox');

/**
 * Data Model for the integer range field.
 *
 * @param {!Object} data Parent element for the field
 *
 * @constructor
 *
 * @author Sharangdhar Chakraborty(schakraborty@yext.com)
 */
yext.location.IntegerRangeModel = function(data) {
  this.minValue = data.minValue;
  this.maxValue = data.maxValue;
  this.displayMinValue = data.displayMinValue;
  this.displayMaxValue = data.displayMaxValue;
  this.indeterminate = data.indeterminate || false;
  this.displayIndeterminate = data.displayIndeterminate || false;
  this.timestamp = data.timestamp;
};

/**
 * Set the min value for this field. The model will emit an event if it is updated
 *
 * @param {number} minValue The target value
 */
yext.location.IntegerRangeModel.prototype.setMinValue = function(minValue) {
  if (minValue != this.minValue) {
    this.minValue = minValue;
    this.emitUpdate();
  }
};

/**
 * Set the max value for this field. The model will emit an event if it is updated
 *
 * @param {number} maxValue The target value
 */
yext.location.IntegerRangeModel.prototype.setMaxValue = function(maxValue) {
  if (maxValue != this.maxValue) {
    this.maxValue = maxValue;
    this.emitUpdate();
  }
};

/**
 * Set the display min value for this field. The model will emit an event if it is updated
 *
 * @param {number} displayMinValue The target value
 */
yext.location.IntegerRangeModel.prototype.setDisplayMinValue = function(displayMinValue) {
  if (displayMinValue != this.displayMinValue) {
    this.displayMinValue = displayMinValue;
    this.emitUpdate();
  }
};

/**
 * Set the display max value for this field. The model will emit an event if it is updated
 *
 * @param {number} displayMaxValue The target value
 */
yext.location.IntegerRangeModel.prototype.setDisplayMaxValue = function(displayMaxValue) {
  if (displayMaxValue != this.displayMaxValue) {
    this.displayMaxValue = displayMaxValue;
    this.emitUpdate();
  }
};

/**
 * Set the indeterminate flag for this field. The model will emit an event if it is updated
 *
 * @param {boolean} indeterminate The target value
 */
yext.location.IntegerRangeModel.prototype.setIndeterminate = function(indeterminate) {
  if (yext.isBoolean(indeterminate) && indeterminate != this.indeterminate) {
    this.indeterminate = indeterminate;
    this.emitUpdate();
  }
};

/**
 * Set the display indeterminate flag for this field. The model will emit an event if it is updated
 *
 * @param {boolean} displayIndeterminate The target value
 */
yext.location.IntegerRangeModel.prototype.setDisplayIndeterminate = function(displayIndeterminate) {
  if (yext.isBoolean(displayIndeterminate) && displayIndeterminate != this.displayIndeterminate) {
    this.displayIndeterminate = displayIndeterminate;
    this.emitUpdate();
  }
};

/**
 * Set the timestamp for this field.
 *
 * @param {string} timestamp The target value
 */
yext.location.IntegerRangeModel.prototype.setTimestamp = function(timestamp) {
  if (yext.isString(timestamp)) {
    this.timestamp = timestamp;
  }
};

/**
 * Emit an updated message using jQuery pub/sub and the instance as context
 */
yext.location.IntegerRangeModel.prototype.emitUpdate = function() {
  $(this).trigger('updated');
};

/**
 * Get the current state of the field as a JSON object
 */
yext.location.IntegerRangeModel.prototype.getJSONData = function() {
  return {
    'minValue': this.minValue,
    'maxValue': this.maxValue,
    'indeterminate': this.indeterminate,
    'timestamp': this.timestamp,
  };
};

/**
 * Update the Range model
 *
 * @param {!Object} data information to fill in a Range model.
 */
yext.location.IntegerRangeModel.prototype.update = function(data) {
  this.setMinValue(data.minValue);
  this.setMaxValue(data.maxValue);
  this.setDisplayMinValue(data.displayMinValue);
  this.setDisplayMaxValue(data.displayMaxValue);
  this.setIndeterminate(data.indeterminate);
  this.setDisplayIndeterminate(data.displayIndeterminate);
  this.setTimestamp(data.timestamp);
};

/**
 * Checks if the model is empty
 */
yext.location.IntegerRangeModel.prototype.isEmpty = function() {
  return this.minValue === '' || this.maxValue === '';
};

/**
 * Models a range select field.
 *
 * @param {!jQuery} $ctx Parent element for the field
 *
 * @constructor
 *
 * @author Sharangdhar Chakraborty(schakraborty@yext.com)
 */
yext.location.IntegerRangeSelect = function($ctx) {
  this.$ctx = $ctx;
  this.$wrapperSelect = $ctx.find('.js-range-select-field').addBack().filter('.js-range-select-field');
  this.$selectMin = $ctx.find('.js-range-select-field-min');
  this.$selectMax = $ctx.find('.js-range-select-field-max');
  this.$fieldValue = $ctx.find('.js-field-value');
  this.$displaySelect = $ctx.closest('.field-display');

  this.buildAndGenerateModel();
  this.storeValue();
  this.bindSelectBox();
  this.setFieldValue();
  this.bindUpdates();
  this.render();
};

/**
 * Builds range model from DOM and generates options.
 */
yext.location.IntegerRangeSelect.prototype.buildAndGenerateModel = function() {
  var data = this.$wrapperSelect.data('value');
  this.model = new yext.location.IntegerRangeModel(data);
  this.generateOptions(data);
};

/**
 * Generates options on the fly for min and max ranges.
 *
 * @param {!Object} data information to generate options.
 */
yext.location.IntegerRangeSelect.prototype.generateOptions = function(data) {
  this.generateSelectOptions(this.$selectMin, data.rangeMinValue, data.rangeMaxValue, data.minValue);
  this.generateSelectOptions(this.$selectMax, data.rangeMinValue, data.rangeMaxValue, data.maxValue);
};

/**
 * Generates options on the fly for a given range.
 *
 * @param {JQuery} select the selection to which options are added
 * @param {number} minRangeValue starting value for the integer range
 * @param {number} maxRangeValue ending value for the integer range
 * @param {number} value currently selected value
 */
yext.location.IntegerRangeSelect.prototype.generateSelectOptions = function(select, minRangeValue, maxRangeValue, value) {
  for (var i = minRangeValue; i <= maxRangeValue; i++) {
    select.append($('<option>', {
      value: i,
      text: i,
      selected: i == value,
    }));
  }
};

/**
 * Manually binding the selectbox.
 */
yext.location.IntegerRangeSelect.prototype.bindSelectBox = function() {
  this.$selectMin.removeClass('no-selectbox').selectbox();
  this.$selectMax.removeClass('no-selectbox').selectbox();
};

/**
 * Bind to the selectMin's and selectMax's change event and bind to the
 * update events from the range model. Publish custom events.
 */
yext.location.IntegerRangeSelect.prototype.bindUpdates = function() {
  var self = this;

  $(this.model).on('updated', function() {
    self.setFieldValue();
    self.emitUpdate();
  });

  this.$selectMin.on('change', function() {
    self.model.setMinValue(self.$selectMin.val());
  });

  this.$selectMax.on('change', function() {
    self.model.setMaxValue(self.$selectMax.val());
  });

  this.$ctx.find('.js-reset-all-range').click(function() {
    self.model.setIndeterminate(false);
    self.render();
  });
};

/**
 * Sets a hidden input to the JSON value of this field
 */
yext.location.IntegerRangeSelect.prototype.setFieldValue = function() {
  this.$fieldValue.val(yext.JSON.stringify(this.model.getJSONData()));
};

/**
 * Broadcast messages with the field as context
 *
 * @param {string} msg Message to trigger
 */
yext.location.IntegerRangeSelect.prototype.message = function(msg) {
  $(this).trigger(msg);
};

/**
 * Renders the field in its current state
 */
yext.location.IntegerRangeSelect.prototype.render = function() {
  if (this.model.minValue != this.$selectMin.val()) {
    this.$selectMin.val(this.model.minValue);
    this.$selectMin.trigger('change');
  }

  if (this.model.maxValue != this.$selectMax.val()) {
    this.$selectMax.val(this.model.maxValue);
    this.$selectMax.trigger('change');
  }

  this.$ctx.find('.js-indeterminate-message').toggle(this.model.indeterminate);
  this.$ctx.find('.js-integer-range-field-edit').toggle(!this.model.indeterminate);
};

/**
 * Reset the field to the stored state
 */
yext.location.IntegerRangeSelect.prototype.reset = function() {
  this.set(this.storedValue);
};

/**
 * Emit an updated message using jQuery pub/sub and the instance as context
 */
yext.location.IntegerRangeSelect.prototype.emitUpdate = function() {
  $(this).trigger('updated');
};

/**
 * Set the range model data and trigger a change event
 *
 * @param {!Object} data information to fill in a Range model.
 */
yext.location.IntegerRangeSelect.prototype.set = function(data) {
  this.model.update(data);
  this.render();
};

/**
 * Store the value so that it can be restored later
 *
 * @param {!Object} data information to fill in a Range model.
 */
yext.location.IntegerRangeSelect.prototype.storeValue = function() {
  this.storedValue = new yext.location.IntegerRangeModel(this.model);
};

/**
 * Get the display value of the field (view mode)
 */
yext.location.IntegerRangeSelect.prototype.getDisplayValue = function() {
  if (this.model.displayIndeterminate) {
    return yext.location.helpers.variousContentMessage();
  } else if (this.model.isEmpty()) {
    return yext.location.helpers.emptyFieldMessage();
  } else {
    // TRANSLATORS: These values are numbers and we are describing a number range
    return yext.msg('{0} to {1}', this.model.displayMinValue, this.model.displayMaxValue);
  }
};
